import React, { useState } from 'react';
import Layout from '../../../components/layout';
import Header from '../../../components/header';
import Icon from '../../../components/icons';
import { useNavigate } from 'react-router-dom';
import { AgGridReact } from 'ag-grid-react';
import Drawer from '../../../components/Drawer';
import CreatePurchasestock from './_components/createPurchasestock';
import Button from '../../../components/elements/button';
import { Dropdown, Menu } from '../../../components/Dropdown';

const Stock: React.FC = () => {
    const navigate = useNavigate();
                const [isOpen, setIsOpen] = useState(false);
            
              const handleClose = () => setIsOpen(false);
                const columnDefs = [
                    { headerName: 'Receipt No', field: 'request-no', headerClass: 'bg-[#f0f0f0]'},
                    { headerName: 'PO Number', field: 'po-number', headerClass: 'bg-[#f0f0f0]' },
                    { headerName: 'Vendor Name', field: 'vendor-name', headerClass: 'bg-[#f0f0f0]' },
                    { headerName: 'Facility', field: 'sacility', headerClass: 'bg-[#f0f0f0]' },
                    { headerName: 'Sub Facility', field: 'sub-facility', headerClass: 'bg-[#f0f0f0]' },
                    { headerName: 'Total Receipt Qty', field: 'qty', headerClass: 'bg-[#f0f0f0]' },
                    { headerName: 'Grand Total', field: 'grand-total', headerClass: 'bg-[#f0f0f0]' },
                    { headerName: 'Receipt Date', field: 'date', headerClass: 'bg-[#f0f0f0]' },
                    { headerName: 'Receipt By', field: 'receipt-by', headerClass: 'bg-[#f0f0f0]' },
                    { headerName: 'Action', field: 'action', headerClass: 'bg-[#f0f0f0]' },
                  ];
                
                  // Define row data
                  const rowData: any[] = [
                    { 'request-no': 'RC 001', 'po-number':'Poultry Zone 01', 'vendor-name': 'John Deere', 'sacility': 'AF Farm 1', 'sub-facility': 'Item 001 Appro...', 'qty':'400.00 kg', 'grand-total':'$800.50', 'date': '15/30/24', 'receipt-by':'John Baker', 'action':''},
                    { 'request-no': 'RC 001', 'po-number':'Poultry Zone 01', 'vendor-name': 'John Deere', 'sacility': 'AF Farm 1', 'sub-facility': 'Item 001 Appro...', 'qty':'400.00 kg', 'grand-total':'$800.50', 'date': '15/30/24', 'receipt-by':'John Baker', 'action':''},
                    { 'request-no': 'RC 001', 'po-number':'Poultry Zone 01', 'vendor-name': 'John Deere', 'sacility': 'AF Farm 1', 'sub-facility': 'Item 001 Appro...', 'qty':'400.00 kg', 'grand-total':'$800.50', 'date': '15/30/24', 'receipt-by':'John Baker', 'action':''},
                    { 'request-no': 'RC 001', 'po-number':'Poultry Zone 01', 'vendor-name': 'John Deere', 'sacility': 'AF Farm 1', 'sub-facility': 'Item 001 Appro...', 'qty':'400.00 kg', 'grand-total':'$800.50', 'date': '15/30/24', 'receipt-by':'John Baker', 'action':''},
                    { 'request-no': 'RC 001', 'po-number':'Poultry Zone 01', 'vendor-name': 'John Deere', 'sacility': 'AF Farm 1', 'sub-facility': 'Item 001 Appro...', 'qty':'400.00 kg', 'grand-total':'$800.50', 'date': '15/30/24', 'receipt-by':'John Baker', 'action':''},
                    { 'request-no': 'RC 001', 'po-number':'Poultry Zone 01', 'vendor-name': 'John Deere', 'sacility': 'AF Farm 1', 'sub-facility': 'Item 001 Appro...', 'qty':'400.00 kg', 'grand-total':'$800.50', 'date': '15/30/24', 'receipt-by':'John Baker', 'action':''},
                    { 'request-no': 'RC 001', 'po-number':'Poultry Zone 01', 'vendor-name': 'John Deere', 'sacility': 'AF Farm 1', 'sub-facility': 'Item 001 Appro...', 'qty':'400.00 kg', 'grand-total':'$800.50', 'date': '15/30/24', 'receipt-by':'John Baker', 'action':''},
                    { 'request-no': 'RC 001', 'po-number':'Poultry Zone 01', 'vendor-name': 'John Deere', 'sacility': 'AF Farm 1', 'sub-facility': 'Item 001 Appro...', 'qty':'400.00 kg', 'grand-total':'$800.50', 'date': '15/30/24', 'receipt-by':'John Baker', 'action':''},
                    { 'request-no': 'RC 001', 'po-number':'Poultry Zone 01', 'vendor-name': 'John Deere', 'sacility': 'AF Farm 1', 'sub-facility': 'Item 001 Appro...', 'qty':'400.00 kg', 'grand-total':'$800.50', 'date': '15/30/24', 'receipt-by':'John Baker', 'action':''},
                   
            
                  ];

    return (
        <Layout>
            <Header title='Purchase Stock'>
            <Header.Right>
                     <Drawer>
                        <Drawer.Button>
                          <Button>Add New Purchase Stock</Button>
                       </Drawer.Button>
                       <Drawer.Content title='Add New Purchase Stock' className='!w-[39.563rem]'>
                            <CreatePurchasestock />
                        </Drawer.Content>
                       </Drawer>
                       <Dropdown>
                        <Dropdown.Button>
                            <Button theme='secondary'>Bulk Actions</Button>
                        </Dropdown.Button>
                        <Dropdown.Content title='Create New Facility' className='!w-[39.563rem]'>
                            <Menu>Move Assets</Menu>
                            <Menu>Export to Excel/CSV/PDF</Menu>
                            <Menu>Print QR Code</Menu>
                        </Dropdown.Content>
                      </Dropdown>
                </Header.Right>
            </Header>
            <div>
        <div className='flex items-center justify-between px-3 border-b border-gray-200 h-[3.75rem]'>
                <div className='flex justify-center items-center gap-2 ms-3'>
                    <a href="" className='w-[1.25rem] h-[1.25]'>
                        <Icon name='circleleft' size={1.25} className='opacity-25' />
                    </a>
                    <span>9 of 100 items</span>
                    <a href="" className='w-[1.25rem] h-[1.25]'>
                        <Icon name='circleright' size={1.25} className='' />
                    </a>
                </div>
                <div>
                    <div className="w-[17.736rem] mx-auto relative group">
                        <div className="relative flex items-center bg-[#F2F2F2] rounded-md border border-[#D9D9D9] h-[2.375rem] text-black">
                            <input
                                type="text"
                                placeholder="Search"
                                className="w-full px-4 focus:outline-none bg-[#F2F2F2] text-black font-medium text-sm"
                            />
                            <button className="min-w-[1.75rem] px-4 h-[2.375rem] font-medium">
                                <Icon name='search' size={1.45} className='text-gray-700' />
                            </button>
                        </div>
                    </div>
                </div></div>
            <div className='bg-[#FAFAFA]'>
                <div className='flex gap-4 px-5 py-2 items-center'>
                    <button className='bg-white border rounded-md border-gray-300 flex gap-2 p-2 text-sm items-center hover:border-gray-400 hover:text-primary transition-all'>
                        Filter <Icon name='filter' size={1.40} />
                    </button>
                    <div className="dropdown dropdown-end">
                        <button tabIndex={0} role='button' className='bg-white border rounded-md border-gray-300 flex gap-2 p-2 text-sm items-center hover:border-gray-400 hover:text-primary transition-all'>
                            <Icon name='grlocation' size={1.20} /> Location <Icon name='arrowdown' size={1.10} />
                        </button>
                        <ul tabIndex={0} className="dropdown-content menu bg-base-100 rounded-box z-1 w-52 p-2 shadow-sm z-10">
                            <li><a>Item 1</a></li>
                            <li><a>Item 2</a></li>
                        </ul>
                    </div>
                    <a href="" className='text-primary font-semibold text-sm'>Clear Filters</a>
                </div>
                <div className="ag-theme-alpine mx-4  h-1/2">
                    <AgGridReact
                        columnDefs={columnDefs} // Pass columnDefs
                        rowData={rowData || []} // Pass rowData
                        pagination={false}
                        domLayout="autoHeight"
                        noRowsOverlayComponent={() => (
                            <div className="flex items-center justify-center h-full">
                                <div className="text-center text-gray-500">
                                    <div className="text-lg font-medium">No Data Found</div>
                                </div>
                            </div>
                        )}
                    />
                </div>
            </div>
            {/* Add your component code here */}
        </div>
        </Layout>
    );
};

export default Stock;